import { type ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { usePlatformName } from '@/hooks/useBranding';

/** Shared header for unauthenticated pages (Landing, Pricing, ApiDocs).
 *  Keeps the nav order + CTAs identical everywhere. */
export function PublicHeader() {
  const name = usePlatformName();
  return (
    <header className="border-b sticky top-0 bg-background/80 backdrop-blur z-20">
      <div className="container flex items-center justify-between h-14">
        <Link to="/" className="font-semibold text-primary">
          {name}
        </Link>
        <nav className="flex items-center gap-1">
          <Button variant="ghost" size="sm" asChild>
            <Link to="/">Anasayfa</Link>
          </Button>
          <Button variant="ghost" size="sm" asChild>
            <Link to="/pricing">Paketler</Link>
          </Button>
          <Button variant="ghost" size="sm" asChild>
            <Link to="/api-docs">API</Link>
          </Button>
          <Button variant="ghost" size="sm" asChild>
            <Link to="/login">Giriş</Link>
          </Button>
          <Button size="sm" asChild>
            <Link to="/register">Ücretsiz Başla</Link>
          </Button>
        </nav>
      </div>
    </header>
  );
}

export function PublicFooter() {
  const name = usePlatformName();
  return (
    <footer className="border-t py-8">
      <div className="container flex flex-wrap items-center justify-between gap-y-3 gap-x-6 text-sm text-muted-foreground">
        <div>© {new Date().getFullYear()} {name}</div>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
          <Link to="/" className="hover:text-foreground hover:underline">
            Anasayfa
          </Link>
          <Link to="/pricing" className="hover:text-foreground hover:underline">
            Paketler
          </Link>
          <Link to="/api-docs" className="hover:text-foreground hover:underline">
            API
          </Link>
          <Link to="/faq" className="hover:text-foreground hover:underline">
            SSS
          </Link>
          <Link to="/privacy" className="hover:text-foreground hover:underline">
            Gizlilik
          </Link>
          <Link to="/terms" className="hover:text-foreground hover:underline">
            Şartlar
          </Link>
          <Link to="/aup" className="hover:text-foreground hover:underline">
            AUP
          </Link>
          <Link to="/login" className="hover:text-foreground hover:underline">
            Giriş
          </Link>
        </div>
      </div>
    </footer>
  );
}

export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <PublicHeader />
      <main className="flex-1">{children}</main>
      <PublicFooter />
    </div>
  );
}
